module.exports = __webpack_public_path__ + "static/media/eisenbahn.521d7050.svg";